export const correoPlantillaNormalize = (source) => {
    return {
        idCorreoPlantilla: source.idCorreoPlantilla ?? source.IdCorreoPlantilla ?? 0,
        asuntoCorreo: source.asuntoCorreo ?? source.AsuntoCorreo ?? '',
        contenidoCorreo: source.contenidoCorreo ?? source.ContenidoCorreo ?? '',
        momento: source.momento ?? source.Momento ?? '',
        enviar: source.enviar ?? source.Enviar ?? false,
        activo: source.activo ?? source.Activo ?? false
    }
}
